export default "__VITE_ASSET__DqGiKiF2__"